
import { 
  FormControl, 
  FormField, 
  FormItem, 
  FormLabel, 
  FormMessage 
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { NotificationFrequency } from "@/types/notification";

// Define a common interface that can be shared between components
export type NotificationFormFields = {
  email_notifications_enabled?: boolean;
  notification_frequency?: NotificationFrequency;
  [key: string]: any; // Allow for additional properties
};

// This interface allows form values to be passed to the component
export interface NotificationSectionProps {
  form: UseFormReturn<NotificationFormFields>;
}

export function NotificationSection({ form }: NotificationSectionProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Notifikationsindstillinger</h3>
      
      {/* Email notifications switch */}
      <FormField
        control={form.control}
        name="email_notifications_enabled"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel>Email notifikationer</FormLabel>
              <div className="text-sm text-muted-foreground">
                Modtag email når der er nye matcher
              </div>
            </div>
            <FormControl>
              <Switch
                checked={field.value ?? true} // Provide default if value is undefined
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      {/* Notification frequency select */}
      <FormField
        control={form.control}
        name="notification_frequency"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Frekvens</FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
              value={field.value || "daily"} // Provide default if value is undefined
              disabled={!form.watch("email_notifications_enabled")}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Vælg frekvens" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="hourly">Hver time</SelectItem>
                <SelectItem value="daily">Daglig</SelectItem>
                <SelectItem value="weekly">Ugentlig</SelectItem>
                <SelectItem value="monthly">Månedlig</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
